<template>
  <div class="wizard">
    <div class="main">
      <div class="taxgift-intro">
        <p>
          <b>{{ $t("integration.smartup_title", "SmartUp (AI agent)") }}</b>
        </p>
      </div>
      <b-form-group
        id="reports-fieldset-select-entity"
        label="WhatsApp Number:"
        label-for="reports-input-select-entity"
      >
        <b-form-input
          id="reports-input-select-entity"
          v-model="form.whatsapp_number"
          required
        ></b-form-input>
      </b-form-group>
    </div>
    <div class="footer">
      <button class="bttn bttn--lg bttn--blue" @click.prevent="closeModal">
        {{ $t("integration.close") }}
      </button>
      <button class="bttn bttn--lg bttn--orange el-right" @click.prevent="addIntegration">
        {{ $t("integration.add_taxgift", "Add Integration") }}
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import urls from "@/constants/urls.js";
import { mapState } from "vuex";

export default {
  data() {
    return {
      form: {
        whatsapp_number: "",
      },
    };
  },

  computed: {
    ...mapState({
      orgId: () => {
        return localStorage.getItem("orgId");
      },
    }),
  },

  methods: {
    closeModal() {
      this.$store.dispatch("getIntegrationsList");
      this.$emit("close-modal");
    },
    addIntegration() {
      const payload = this.form;
      // Please fill in API Call here
      axios
        .post(urls.addIntegration(this.orgId, "smartup"), payload)
        .then(() => {
          this.$_notificationsMixin_makeToast("Success", this.$t("account.success_edit"));
          this.$emit("close-modal");
          this.$store.dispatch("getIntegrationsList");
        })
        .catch(this.$_notificationsMixin_handleCatch);
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  justify-content: space-between;
}
.el-right {
  margin-left: auto;
}
</style>
